import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const checkRouteAccess = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  const { hasAccess } = to.meta;
  if (hasAccess) next();
  else window.history.replaceState(null, '', '/not-found');
};
